var map = {
	"./basme/1.jpg": "843d",
	"./cacealma/1.jpg": "7883",
	"./gewalt/1.jpg": "f7cc",
	"./jurnal-tetelu/1.jpg": "275b",
	"./la-inceput/1.jpg": "b408",
	"./nichita/1.jpg": "1fc1",
	"./oaianeagra/1.jpg": "cb02",
	"./peei/1.jpg": "14de",
	"./scrisoare-tata/1.jpg": "8a58",
	"./scrisori-front/1.jpg": "8061",
	"./urletul/1.jpg": "b804"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3100";